<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             top='10vh' @close='dialogClose' width='1050px'>
    <el-form v-loading='formLoading' :model='form' label-width='140px' label-position='right'
             ref='ruleForm' class='p10 formHeight'>
      <div-border label='基础信息' class='p20'>
        <el-row :gutter='10'>
          <el-col :span='12'>
            <el-form-item label='供应商：'>
              <span>{{ form.fleetName |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='品牌：'>
              <span>{{ form.brandName |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='交单日期：'>
              <span>{{ form.surrenderDate |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='快递公司：'>
              <span>{{ form.expressCompany |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='邮寄单号：'>
              <span>{{ form.expressNumber |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='交单备注：'>
              <span>{{ form.surrenderRemarks |valFormat }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>
      <div-border label='委托车列表' class='p20'>
        <el-form :model='searchForm' label-width='80px' ref='searchForm' :inline='true'>
          <el-form-item label='车架号：'>
            <el-input v-model='searchForm.frameNumber' size='mini' type='number'
                      placeholder='请输入车架号' />
          </el-form-item>
          <el-form-item>
            <el-button size='small' style='margin-left: 10px;' class='searchBtn' @click='searchBtn'>
              查询
            </el-button>
            <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref='searchTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          sizi='mini'
          max-height='200'
          :header-cell-style='headerCellStyle'>
          <el-table-column label='批次号' prop='batchNumber' align='center' width='140' />
          <el-table-column label='运单号' prop='waybillNo' align='center' width='140' />
          <el-table-column label='车架号' prop='frameNumber' align='center' width='180' />
          <el-table-column label='品牌' prop='brandName' align='center' />
          <el-table-column label='型号' prop='modelName' align='center' width='120' />
          <el-table-column label='运输方式' prop='transportMode' align='center'
                           :formatter='transportModeFormat' />
          <el-table-column label='起运地' prop='departurePlace' align='center' width='180' />
          <el-table-column label='目的地' prop='arrivePlace' align='center' width='180' />
          <el-table-column label='运单类型' prop='waybillType' align='center' />
        </el-table>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          size='mini'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div-border>

      <div-border label='操作记录' class='p20'>
        <el-table
          ref='registerTable'
          row-key='id'
          :data='form.operateRecordList'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
          <el-table-column prop='operateType' label='操作类型' align='center' />
          <el-table-column prop='operationName' label='操作人' align='center' />
          <el-table-column prop='remark' label='备注' align='center' />
        </el-table>
      </div-border>
    </el-form>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { portWarehouseCostDetail } from '@/service/warehouse';
  import { receiptDetails, receiptFormSearch } from '@/service/receipt';

  export default {
    name: 'supplierDeliveryInfo',
    components: { divBorder },
    data() {
      return {
        dialogTitle: '详情',
        dialogVisible: false,
        defaultForm: {},
        form: {},
        tableLoading: false,
        tableData: [],
        total: 0,
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        formLoading: false,
        searchForm: {
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
      };
    },
    filters: {
      valFormat(str) {
        if (str) {
          return str;
        } else {
          return '无';
        }
      },
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
    },
    methods: {
      transportModeFormat(r, c, cellValue) {
        switch (cellValue) {
          case '1':
            return '公路';
          case '2':
            return '水路';
          case '3':
            return '水陆联运';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await receiptFormSearch(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      dialogOpen(id) {
        this.searchForm.id = id;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.getDetails(id);
        this.getTableData();
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      async getDetails(id) {
        this.formLoading = true;
        const {
          status,
          message,
          data,
        } = await receiptDetails(id);
        this.formLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.form = data;
      },
    },
  };
</script>

<style lang='scss' scoped></style>
